import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Header from "../components/Header";

export default function Register() {
  const { t, i18n } = useTranslation();
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await register(form.email, form.password, form.name, i18n.language);
      nav("/dashboard");
    } catch (ex) {
      setErr(ex.response?.data?.detail || t("common.error"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen relative" data-testid="register-page">
      <div className="absolute -top-20 -right-20 w-96 h-96 bg-mint-soft blob animate-blob pointer-events-none" />
      <div className="absolute -bottom-20 -left-20 w-96 h-96 bg-cobalt-100 blob animate-blob pointer-events-none" style={{ animationDelay: "-5s" }} />
      <Header />
      <main className="relative">
        <div className="max-w-md mx-auto px-5 py-16">
          <div className="card-soft p-8">
            <div className="overline mb-2">{t("common.register")}</div>
            <h1 className="font-display font-bold text-3xl tracking-tight">{t("auth.registerTitle")}</h1>
            <p className="mt-2 text-ink-700">{t("auth.registerSub")}</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <label className="block">
                <span className="text-sm font-semibold">{t("common.name")}</span>
                <input value={form.name} onChange={set("name")} className="input-soft mt-2" data-testid="register-name" />
              </label>
              <label className="block">
                <span className="text-sm font-semibold">{t("common.email")}</span>
                <input type="email" required value={form.email} onChange={set("email")} className="input-soft mt-2" data-testid="register-email" />
              </label>
              <label className="block">
                <span className="text-sm font-semibold">{t("common.password")}</span>
                <input type="password" required minLength={6} value={form.password} onChange={set("password")} className="input-soft mt-2" data-testid="register-password" />
              </label>
              {err && <div className="text-sm text-destructive bg-red-50 rounded-xl p-3" data-testid="register-error">{err}</div>}
              <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="register-submit">
                {loading ? t("common.loading") : t("common.register")}
              </button>
            </form>
            <div className="mt-6 text-sm text-ink-700 text-center">
              {t("auth.haveAccount")} <Link to="/login" className="text-cobalt-600 font-semibold hover:underline">{t("auth.loginHere")}</Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
